interface DetailRowProps {
  name: string;
  value: string;
  nameWidth?: string;
  valueWidth?: string;
  right?: boolean;
  display?: boolean;
  classValue?: string;
}

export const DetailRow = ({
  name,
  value,
  nameWidth = 'col-6',
  valueWidth = 'col-6',
  right = false,
  display = true,
  classValue = '',
}: DetailRowProps) => {
  if (!value || !`${value}`.replace(/ /g, '')) {
    return null;
  }
  return (
    <div className={display ? `row` : 'd-none'}>
      <div className={nameWidth}>
        <div className="colfax-regular">{name}:</div>
      </div>
      <div className={valueWidth}>
        <div className={`colfax-regular ${right ? 'text-end' : ''} ${classValue}`}>{value}</div>
      </div>
    </div>
  );
};
